module.exports = __webpack_public_path__ + "img/back-arrow.7b8921e9.svg";